
import Button from '../../../components/base/Button';
import { useTranslation } from 'react-i18next';

export default function CasesPreviewSection() {
  const { t, i18n } = useTranslation();

  const cases = [
    {
      id: 1,
      categoryKey: 'case_baby_category',
      platformKey: 'case_baby_platform',
      titleKey: 'case_baby_title',
      descKey: 'case_baby_desc',
      metrics: {
        exposure: '1.2M',
        engagement: '8.3%',
        sales: '+180%'
      },
      image: '/resources/baby-brand-001.jpg',
      tags: {
        zh: ['小红书', '母婴', 'KOL营销'],
        en: ['Xiaohongshu', 'Baby & Maternity', 'KOL Marketing']
      }
    },
    {
      id: 2,
      categoryKey: 'case_beauty_category',
      platformKey: 'case_beauty_platform',
      titleKey: 'case_beauty_title',
      descKey: 'case_beauty_desc',
      metrics: {
        conversion: '3.5%',
        liveUV: '+220%',
        roas: '2.8x'
      },
      image: '/resources/beauty-brand-001.jpg',
      tags: {
        zh: ['抖音', 'TikTok', '美妆', '跨境'],
        en: ['Douyin', 'TikTok', 'Beauty', 'Cross-border']
      }
    },
    {
      id: 3,
      categoryKey: 'case_smart_category',
      platformKey: 'case_smart_platform',
      titleKey: 'case_smart_title',
      descKey: 'case_smart_desc',
      metrics: {
        roas: '2.8',
        followers: '+420%',
        countries: '15+'
      },
      image: '/resources/smart-home-001.jpg',
      tags: {
        zh: ['跨境', '智能家居', '多平台'],
        en: ['Cross-border', 'Smart Home', 'Multi-platform']
      }
    }
  ];

  const getMetricLabel = (key: string) => {
    const metricMap: { [key: string]: string } = {
      exposure: t('metric_exposure'),
      engagement: t('metric_engagement'),
      sales: t('metric_sales'),
      conversion: t('metric_conversion'),
      liveUV: t('metric_live_uv'),
      roas: t('metric_roas'),
      followers: t('metric_followers'),
      countries: t('metric_countries')
    };
    return metricMap[key] || key;
  };

  const handleScrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('cases_title')}
          </h2>
          <p className="text-lg text-gray-600 mb-2">{t('cases_subtitle')}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('cases_description')}
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {cases.map((caseItem) => (
            <div key={caseItem.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
              <div className="relative overflow-hidden">
                <img 
                  src={caseItem.image}
                  alt={t(caseItem.titleKey)}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium text-gray-700">
                  {t(caseItem.platformKey)}
                </div>
                <div className="absolute bottom-4 left-4">
                  <div className="flex flex-wrap gap-2">
                    {caseItem.tags[i18n.language as 'zh' | 'en']?.map((tag, index) => (
                      <span key={index} className="bg-blue-600/80 text-white px-2 py-1 rounded text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <div className="text-sm text-blue-600 font-medium mb-2">
                  {t(caseItem.categoryKey)}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {t(caseItem.titleKey)}
                </h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                  {t(caseItem.descKey)}
                </p>
                
                <div className="grid grid-cols-3 gap-4 mb-4">
                  {Object.entries(caseItem.metrics).map(([key, value]) => (
                    <div key={key} className="text-center">
                      <div className="text-lg font-bold text-blue-600">{value}</div>
                      <div className="text-xs text-gray-500">
                        {getMetricLabel(key)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={handleScrollToContact}
            className="cursor-pointer"
          >
            <Button size="lg" className="px-8">
              <i className="ri-arrow-right-line mr-2"></i>
              {t('btn_view_more_cases')}
            </Button>
          </button>
        </div>
      </div>
    </section>
  );
}
